import { Box, Text } from '@chakra-ui/react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import TriggerName from './formFields/TriggerName';
import TriggerDescription from './formFields/TriggerDescription';
import TriggerEnabled from './formFields/TriggerEnabled';
import TriggerType from './formFields/TriggerType';
import TriggerEntityDropdown from './formFields/TriggerEntityDropdown';
import useGetCompanyList from '@/queries/company/useGetCompanyList';
import useGetPartnerList from '@/queries/partner/useGetPartnerList';
import useGetWholesalerList from '@/queries/wholesaler/useGetWholesalerList';
import { useTriggerForm } from './useTriggerForm.js';
import { showsEntityDropdown } from './triggerFormConstants.js';
import config from '@/config';

const TriggerBasicInfo = ({ darkMode, errors, touched }) => {
    const { currentPartner, currentWholesaler } = useSelector((state) => {
        return { ...state.navigationLists };
    });

    const { formData } = useTriggerForm();

    const { requiredScope } = useSelector((state) => state.login);
    const [companyList, setCompanyList] = useState([]);
    const [partnerList, setPartnerList] = useState([]);
    const [wholesalerList, setWholesalerList] = useState([]);
    const isCompanyAdmin = requiredScope === 20;

    // Only the scope that can actually retarget the trigger gets an entity
    // picker, so only that scope fetches the list behind it (2930).
    const hasEntityDropdown = showsEntityDropdown(
        formData?.triggerType,
        requiredScope,
    );

    useGetCompanyList(
        currentPartner,
        requiredScope,
        setCompanyList,
        hasEntityDropdown && formData?.triggerType === config.scope.json['20'],
    );
    useGetPartnerList(
        currentWholesaler,
        requiredScope,
        setPartnerList,
        hasEntityDropdown && formData?.triggerType === config.scope.json['40'],
    );
    useGetWholesalerList(
        setWholesalerList,
        hasEntityDropdown && formData?.triggerType === config.scope.json['60'],
    );

    return (
        <Box margin="20px 0px">
            <Text
                fontSize="xl"
                fontWeight="semibold"
                mb={6}
                color={darkMode ? 'white' : 'black'}>
                Trigger Information
            </Text>

            <TriggerName
                errors={errors}
                touched={touched}
                darkMode={darkMode}
            />

            <TriggerEnabled darkMode={darkMode} />

            <TriggerType
                darkMode={darkMode}
                errors={errors}
                touched={touched}
                isCompanyAdmin={isCompanyAdmin}
            />
            {!isCompanyAdmin && (
                <TriggerEntityDropdown
                    darkMode={darkMode}
                    errors={errors}
                    touched={touched}
                    companies={companyList}
                    partners={partnerList}
                    wholesalers={wholesalerList}
                    isCompanyAdmin={isCompanyAdmin}
                    requiredScope={requiredScope}
                />
            )}

            <TriggerDescription
                errors={errors}
                touched={touched}
                darkMode={darkMode}
            />
        </Box>
    );
};

export default TriggerBasicInfo;
